/**
 * AEG Theme Configuration
 * Based on LA Kings theme with AEG branding
 */

import kingsTheme from './kingsTheme';

const aegTheme = {
    ...kingsTheme,

    // Client identification
    clientId: 'aeg',
    clientName: 'AEG',

    // Kings-only features must not leak through the spread
    features: {},

    // Logo configuration - AEG logo as primary, theteam as secondary
    logos: {
        primary: require('../../components/Login/images/aeg.png'),
        primaryHeight: '85px',
        secondary: require('../../components/Login/images/theteam.png'),
        secondaryHeight: '52px',
    },

    forms: {
        ...kingsTheme.forms,
        loginFormOpacity: '0.9',
    },
};

export default aegTheme;
